
<div class="container">
  <div class="role-row">
    <mat-form-field appearance="outline" class="flex-1-1-100 lt-md-100">
      <mat-label>Preparer Role</mat-label>
      <mat-select [(ngModel)]="selectedContributor">

        <mat-option *ngFor="let item of data" [value]="item.name">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="role-row">
    <mat-form-field appearance="outline" class="flex-1-1-100 lt-md-100">
      <mat-label>Reviewer Role</mat-label>
      <mat-select [(ngModel)]="selectedReviewer">
        <mat-option *ngFor="let item of data" [value]="item.name">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="button-row">
    <button class="save-btn"
            (click)="saveTxpConfigurationSetting()"
            [disabled]="!selectedContributor || !selectedReviewer">
      Save Settings
    </button>
  </div>
</div>
